import { Kpi } from '@tran-monorepo/interfaces/applications';

export interface KpiGridRow extends Kpi {
    startValueLabel: string;
    targetValueLabel: string;
}

export function toKpiGridRows(kpis: Kpi[]): KpiGridRow[] {
    return kpis.map(kpi => {
        const startUnitSuffix = kpi.startUnit?.symbol ? ` ${kpi.startUnit.symbol}` : '';
        const targetUnitSuffix = kpi.targetUnit?.symbol ? ` ${kpi.targetUnit.symbol}` : '';

        return {
            ...kpi,
            startValueLabel: `${kpi.startValue ?? ''}${startUnitSuffix}`,
            targetValueLabel: `${kpi.targetValue ?? ''}${targetUnitSuffix}`
        };
    });
}
